import { Component } from '@angular/core';

/** Stub: el `sessionHomeRedirectGuard` siempre redirige; este componente no se muestra. */
@Component({
  selector: 'app-session-home-redirect',
  template: '',
  standalone: true,
})
export class SessionHomeRedirectComponent {}
